<template>
  <van-popup
    v-model="visible"
    :style="{ background: 'rgba(0, 0, 0, 0.9)' }"
    :position="'center'"
    :close-on-click-overlay="true"
    :round="false"
    get-container="body"
    @close="handleClose"
  >
    <div class="image-preview-popup">
      <div class="close-btn" @click.stop="handleClose">×</div>
      <van-swipe
        ref="swiper"
        :initial-swipe="initialSwipe"
        :loop="false"
        :show-indicators="false"
        class="preview-swiper"
        @change="handleSwipeChange"
      >
        <van-swipe-item
          v-for="(item, index) in imageList"
          :key="index"
          class="swipe-item"
        >
          <img 
            v-if="item.line_cover" 
            :src="item.line_cover" 
            alt="preview"
            class="preview-image"
            @error="handleImageError"
          />
          <div v-else class="preview-placeholder">
            <span>图片加载失败</span>
          </div>
        </van-swipe-item>
      </van-swipe>
    </div>
  </van-popup>
</template>

<script>
export default {
  name: 'ImagePreviewPopup',
  props: {
    value: {
      type: Boolean,
      default: false
    },
    imageList: {
      type: Array,
      default: () => []
    },
    initialIndex: {
      type: Number,
      default: 0
    }
  },
  computed: {
    visible: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('input', val)
      }
    },
    initialSwipe() {
      return this.initialIndex
    }
  },
  watch: {
    visible(newVal) {
      if (newVal && this.$refs.swiper) {
        this.$nextTick(() => {
          if (this.$refs.swiper && typeof this.$refs.swiper.swipeTo === 'function') {
            this.$refs.swiper.swipeTo(this.initialIndex)
          }
        })
      }
    },
    initialIndex() {
      if (this.visible && this.$refs.swiper) {
        this.$nextTick(() => {
          if (this.$refs.swiper && typeof this.$refs.swiper.swipeTo === 'function') {
            this.$refs.swiper.swipeTo(this.initialIndex)
          }
        })
      }
    }
  },
  methods: {
    handleClose() {
      this.$emit('input', false)
    },
    handleImageError(event) {
      console.warn('图片加载失败')
    },
    handleSwipeChange(index) {
      this.$emit('swipe-change', index)
    }
  }
}
</script>

<style scoped>
.image-preview-popup {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 690px;
  max-width: 90vw;
  max-height: 90vh;
  position: relative;
}

.preview-swiper {
  width: 100%;
  height: 100%;
}

.swipe-item {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
}

.preview-image {
  width: 100%;
  height: auto;
  max-height: 90vh;
  object-fit: contain;
  display: block;
}

.preview-placeholder {
  width: 690px;
  height: 400px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #f0f0f0;
  color: #999;
  font-size: 28px;
}

.close-btn {
  position: absolute;
  top: 12px;
  right: 12px;
  width: 48px;
  height: 48px;
  line-height: 48px;
  text-align: center;
  font-size: 32px;
  color: #fff;
  background: rgba(0, 0, 0, 0.35);
  border-radius: 50%;
  z-index: 2;
  user-select: none;
}

.close-btn:active {
  background: rgba(0, 0, 0, 0.5);
}
</style>

